import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Divider from '@material-ui/core/Divider';
import Co2NowStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/co2/Co2NowStatsTotalSpeedo";
import Co2TodayStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/co2/Co2TodayStatsTotalSpeedo";
import Co2WeekStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/co2/Co2WeekStatsTotalSpeedo";
import Co2MonthStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/co2/Co2MonthStatsTotalSpeedo";
import CO2ChartSet from "../PowerStatTotalCharts/CO2TotalChartSet";

// style sheet imported locally // 
import styles from '../../../../../assets/widgets/widgetStyles/commonStyles'

const useStyles = makeStyles(styles);

export const CO2PowerStatsTotalSet = (props) => {
  const classes = useStyles();
  return (
    <div>
     <Grid container spacing={0} className={classes.powerStatsTablayout}>
       <Divider variant="fullWidth" className={classes.powerStatsTabDivider} />
       <Grid items md={3}  className={classes.PowerStatsTabHeaderText}>
           {props.language.now}
           <Co2NowStatsTotalSpeedo 
            powerData={props.powerData}
            powerStatTotal={props.powerStatTotal} 
            data={props.data} 
            widget={props.widget}
            energy={props.energy}/> 
        </Grid>
       <Grid items md={3}  className={classes.PowerStatsTabHeaderText}>
           {props.language.today}
           <Co2TodayStatsTotalSpeedo  
           powerData={props.powerData} 
           powerStatTotal={props.powerStatTotal}
           data={props.data} 
           widget={props.widget}
           energy={props.energy} /> 
           </Grid>
       <Grid items md={3} className={classes.PowerStatsTabHeaderText}>
           {props.language.thisWeek}
           <Co2WeekStatsTotalSpeedo 
            powerData={props.powerData}
            powerStatTotal={props.powerStatTotal} 
            data={props.data} 
            widget={props.widget}
            energy={props.energy}/> 
           </Grid>
       <Grid items md={3}  className={classes.PowerStatsTabHeaderText}>
       {props.language.thisMonth}
       <Co2MonthStatsTotalSpeedo 
        powerData={props.powerData} 
        powerStatTotal={props.powerStatTotal}
        data={props.data} 
        widget={props.widget} 
        energy={props.energy}/> 
       </Grid>

       <Grid items md={12}>
       <CO2ChartSet
        widget={props.widget}
        powerData={props.powerData}
        powerStatTotal={props.powerStatTotal}
        totalPowerDataCharts={props.totalPowerDataCharts}
         data={props.data} 
         energy={props.energy}
         language={props.language}
        />
       </Grid>

      </Grid>
      
    </div>
  );
};

export default CO2PowerStatsTotalSet;